export enum EDPEX_PROJECT_STATUS {
    DRAFT = 'DRAFT', // ร่าง
    PENDING_PROCESS = 'PENDING_PROCESS', // รอดำเนินการ
    PROCESS = 'PROCESS', // กำลังดำเนินการ
    OVERDUE = 'OVERDUE', // เกินกำหนดระยะเวลา
    COMPLETED = 'COMPLETED', // ดำเนินการเสร็จสิ้น
}

export enum EDPEX_PROJECT_USER_RESPONSIBLE {
    ADMIN = 'รองบริหาร', // i18n-ignore (backend value)
    RESEARCH_AND_ACADEMIC = 'รองวิจัยและวิชาการ' // i18n-ignore (backend value)
}

export enum EDPEX_PROJECT_DIVISION_RESPONSIBLE {
    ACADEMIC = 'วิชาการ', // i18n-ignore (backend value)
    ADMINISTRATIVE = 'บริหาร' // i18n-ignore (backend value)
}

type filterData = {
    label: string, value: string;
}
export enum EDPEX_PROJECT_DEPARTMENT_RESPONSIBLE {
    ACADEMIC_OFFICE = 'สำนักงานวิชาการ', // i18n-ignore (backend value)
    COLLEGE_OFFICE = 'สำนักงานวิทยาลัย' // i18n-ignore (backend value)
}

export const ed_pex_department_responsible: filterData[] = [
    {
        label: "สำนักงานวิชาการ", // i18n-ignore (translated at render site)
        value: EDPEX_PROJECT_DEPARTMENT_RESPONSIBLE.ACADEMIC_OFFICE
    },
    {
        label: "สำนักงานวิทยาลัย", // i18n-ignore (translated at render site)
        value: EDPEX_PROJECT_DEPARTMENT_RESPONSIBLE.COLLEGE_OFFICE
    },
]
export const ed_pex_project_user_responsible: filterData[] = [
    {
        label: "รองบริหาร", // i18n-ignore (translated at render site)
        value: EDPEX_PROJECT_USER_RESPONSIBLE.ADMIN
    },
    {
        label: "รองวิจัยและวิชาการ", // i18n-ignore (translated at render site)
        value: EDPEX_PROJECT_USER_RESPONSIBLE.RESEARCH_AND_ACADEMIC
    },
]
export const ed_pex_project_status_data: { label: string, value: string }[] = [
    {
        label: "บันทึกร่าง", // i18n-ignore (translated at render site)
        value: EDPEX_PROJECT_STATUS.DRAFT
    },
    {
        label: "รอดำเนินการ", // i18n-ignore (translated at render site)
        value: EDPEX_PROJECT_STATUS.PENDING_PROCESS
    },
    {
        label: "กำลังดำเนินการ", // i18n-ignore (translated at render site)
        value: EDPEX_PROJECT_STATUS.PROCESS
    },
    {
        label: "เกินกำหนดระยะเวลา", // i18n-ignore (translated at render site)
        value: EDPEX_PROJECT_STATUS.OVERDUE
    },
    {
        label: "ดำเนินการเสร็จสิ้น", // i18n-ignore (translated at render site)
        value: EDPEX_PROJECT_STATUS.COMPLETED
    },
]



export enum EDPEX_PROJECT_AMENDMENT_NAME {
    DURATION = 'ขอปรับเปลี่ยนระยะเวลาเริ่มต้นดำเนินการระยะเวลาสิ้นสุดดำเนินการ', // i18n-ignore (backend value)
    BUDGET = 'ขอปรับเปลี่ยนข้อมูลการใช้เงิน', // i18n-ignore (backend value)
}


export const expex_project_amendment_name_data: { label: string, value: string }[] = [
    {
        label: EDPEX_PROJECT_AMENDMENT_NAME.BUDGET,
        value: EDPEX_PROJECT_AMENDMENT_NAME.BUDGET,
    },
    {
        label: EDPEX_PROJECT_AMENDMENT_NAME.DURATION,
        value: EDPEX_PROJECT_AMENDMENT_NAME.DURATION,
    },
]

export enum EDPEX_PROJECT_AMENDMENT_STATUS {
    PENDING = 'PENDING', // รอพิจารณา
    APPROVED = 'APPROVE', // อนุมัติ
    REJECTED = 'REJECT', // ไม่อนุมัติ
}


export const edpex_project_amendment_status: { label: string, value: string }[] = [
    {
        label: "รอพิจารณา", // i18n-ignore (translated at render site)
        value: EDPEX_PROJECT_AMENDMENT_STATUS.PENDING
    },
    {
        label: "อนุมัติ", // i18n-ignore (translated at render site)
        value: EDPEX_PROJECT_AMENDMENT_STATUS.APPROVED
    },
    {
        label: "ไม่อนุมัติ", // i18n-ignore (translated at render site)
        value: EDPEX_PROJECT_AMENDMENT_STATUS.REJECTED
    },
]